import { LIGHT_PRODUCT_LIST_FIELDS } from './fragments/productFields';

// Uses a smaller variant page size (2) originally; retain that behavior inline instead of shared helper.
const getFilteredProductsFromCollection = (
    categoryHandle,
    categoryId,
    filters,
    country
) => `${country ? `query @inContext(country: ${country})` : ''} {
  collection(handle: "${categoryHandle}") {
    handle
    products(first: 24,
      filters: { productMetafield: { namespace: "${filters.namespace}", key: "${filters.key}", value: "${
          filters.value
      }" } }
    ) {
      edges {
        node {
          ${LIGHT_PRODUCT_LIST_FIELDS({
              variantFirst: 2,
              imageCount: categoryHandle === 'all-torsos-new-website' || categoryId === 'bodies' ? 50 : 4,
          })}
        }
        cursor
      }
      pageInfo { hasNextPage }
    }
  }
}`;

export default getFilteredProductsFromCollection;
